export const authHttpKey = 'Authorization';
export const authHttpPrefix = 'Bearer ';



// WEBPACK FOOTER //
// /dist/src/app/security/authorization/authorization.const.ts